import script from "./ProfilerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilerCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfilerCard.vue?vue&type=style&index=0&id=15344922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15344922"]])

export default __exports__